import { BaseClient } from '../BaseClient';
import {
  GeneratedTask,
  GeneratedTaskDocument,
  GeneratedTaskDocumentList,
  GeneratedTaskList,
  ImpliedTask,
  ImpliedTaskList,
} from '../compiled-protos/action_item';
import { ActionItemClient as ActionItemGrpcClient } from '../compiled-protos/action_item.client';
import { type DateRange, Empty } from '../compiled-protos/common';

class ActionItemClient extends BaseClient {
  self: ActionItemGrpcClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ActionItemGrpcClient(this.transport);
  }

  public async BatchGetGeneratedTask(req: GeneratedTask) {
    let res = GeneratedTaskList.create();
    try {
      res = await this.self.batchGetGeneratedTask(req, this.getMetaDataWithoutCache()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetGeneratedTask(req: GeneratedTask) {
    let res = GeneratedTask.create();
    try {
      res = await this.self.getGeneratedTask(req, this.getMetaDataWithoutCache()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async CreateGeneratedTask(req: GeneratedTask) {
    let res = GeneratedTask.create();
    try {
      res = await this.self.createGeneratedTask(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async UpdateGeneratedTask(req: GeneratedTask) {
    let res = GeneratedTask.create();
    try {
      res = await this.self.updateGeneratedTask(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async DeleteGeneratedTask(req: GeneratedTask) {
    let res = Empty.create();
    try {
      res = await this.self.deleteGeneratedTask(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async CreateGeneratedTaskDocument(req: GeneratedTaskDocument) {
    let res = GeneratedTaskDocument.create();
    try {
      res = await this.self.createGeneratedTaskDocument(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async GetGeneratedTaskDocument(req: GeneratedTaskDocument) {
    let res = GeneratedTaskDocument.create();
    try {
      res = await this.self.getGeneratedTaskDocument(req, this.getMetaDataWithoutCache()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGetGeneratedTaskDocument(req: GeneratedTaskDocument) {
    let res = GeneratedTaskDocumentList.create();
    try {
      res = await this.self.batchGetGeneratedTaskDocument(req, this.getMetaDataWithoutCache())
        .response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async UpdateGeneratedTaskDocument(req: GeneratedTaskDocument) {
    let res = GeneratedTaskDocument.create();
    try {
      res = await this.self.updateGeneratedTaskDocument(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async DeleteGeneratedTaskDocument(req: GeneratedTaskDocument) {
    let res = Empty.create();
    try {
      res = await this.self.deleteGeneratedTaskDocument(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGetImpliedTask(req: DateRange) {
    let res = ImpliedTaskList.create();
    try {
      res = await this.self.batchGetImpliedTask(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }
}

export {
  GeneratedTask,
  GeneratedTaskDocument,
  GeneratedTaskDocumentList,
  GeneratedTaskList,
  ImpliedTask,
  ImpliedTaskList,
  ActionItemClient,
};
